import React from "react";

export interface PlayIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const PlayIcon: React.FC<PlayIconProps> = ({ width = 18, height = 18, color = "#226CF5" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.95644 7.7836C11.2795 7.01185 11.2795 5.10024 9.95644 4.32849L3.00765 0.275024C1.67433 -0.502743 -9.54522e-05 0.458999 -9.55196e-05 2.00258L-9.5874e-05 10.1095C-9.59415e-05 11.6531 1.67433 12.6148 3.00765 11.8371L9.95644 7.7836Z"
        fill={color}
      />
    </svg>
  );
};

export default PlayIcon;
